
import { AxiosHelper } from '../helpers/AxiosHelper';


const ListRoomOverview = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/ListRoomOverview', formData);
}


const ListExpectedCheckInWithoutRoom = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/ListExpectedCheckInWithoutRoom', formData);
}


const UpdateRoomGovernanceStatus = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/UpdateRoomGovernanceStatus', formData);
}


const UpdateRoomObservations = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/UpdateRoomObservations', formData);
}


const UpdateRoomDoNotDisturb = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/UpdateRoomDoNotDisturb', formData);
}


const UpdateReservationObservations = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/UpdateReservationObservations', formData);
}


const GetExpectedOccupancy = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/GetExpectedOccupancy', formData);
}


const ListPointOfSaleItems = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/ListPointOfSaleItems', formData);
}


const LaunchPointOfSaleItems = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/LaunchPointOfSaleItems', formData);
}


const ListRoomBlocking = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/ListRoomBlocking', formData);
}


const AddRoomBlocking = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/AddRoomBlocking', formData);
}


const RemoveRoomBlocking = async (formData: FormData) => {
    return AxiosHelper.post('/PartnerPms/RemoveRoomBlocking', formData);
}


const PartnerPmsService = {
    ListRoomOverview,
    ListExpectedCheckInWithoutRoom,
    UpdateRoomGovernanceStatus,
    UpdateRoomObservations,
    UpdateRoomDoNotDisturb,
    UpdateReservationObservations,
    GetExpectedOccupancy,
    ListPointOfSaleItems,
    LaunchPointOfSaleItems,
    ListRoomBlocking,
    AddRoomBlocking,
    RemoveRoomBlocking
}

export default PartnerPmsService;